import { makeVar } from '@apollo/client';
import { accountingTableStateDefault } from './defaultValues';
import makePersistentVar from './utilities/makePersistentVar';

/**
 * Reactive Vars (for purpose of local, global State) ->
 * use makeVar for non-persistant, use makeVarPersistent to persist in
 * local storage with session/local designation
 */

/*
 * TEST Variables
 */
// mock client number used for MSW TIR Admin calls
export const numberOfTIRClients = makeVar(236);

/*
 * APP Variables
 */
// global reference for currently active account - local storage required for proper persistence in certain browser environments
export const lastAccessVar = makePersistentVar(
  {
    id: null,
    userId: null,
  },
  'lastAccessVar',
  'local',
);

// reference for custom configs on certain screens (populated downstream from Auth0, in places where config may be unavailable)
export const customLogoUrlVar = makeVar(null);
// persisted references for the currently selected account and default account, for global/non-tree references
export const currentAccountIdVar = makePersistentVar(null, 'currentAccountId');
export const primaryAccountIdVar = makePersistentVar(null, 'primaryAccountId');
// global reference for the timezone associated with the currently active account
export const currentAccountTimezoneVar = makeVar(null);
// indicates if the user is using the help widget or not
export const helpWidgetActiveVar = makeVar(false);
// global reference for application error(s)
export const errorVar = makeVar(null);
// global reference for check performed on login for browser compatibility
export const browserCheckVar = makePersistentVar(
  {
    confirmedBadBrowser: false,
    confirmedBadOS: false,
    currentBrowser: null,
    currentOS: null,
    confirmedMobile: false,
  },
  'browserCheck',
);
// global var for reference to current (in-memory only) accessToken
export const accessTokenVar = makeVar(null);
// variable to track user preference for hiding/showing global help widget
export const showHelpWidgetVar = makePersistentVar(true, 'showHelpWidget');
// Common object for persisting table page sizes
export const tableStateVar = makePersistentVar({}, `tableState`);
// used to make app aware that account generation is in progress
export const creatingAccountVar = makeVar(false);
// Accounting transaction table state management
export const accountingTableStateVar = makePersistentVar(
  accountingTableStateDefault,
  'accountingTableState',
);
// global var for current tax year of the account
export const currentAccountTaxYearVar = makePersistentVar(
  null,
  'currentAccountTaxYearVar',
);
// manages the Tax tx table state variables
export const costBasisAssignmentTableStateVar = makePersistentVar(
  {
    default: {
      sortColumn: 'date',
      sortOrder: 'desc',
      pageSize: 5,
    },
  },
  'costBasisAssignmentTableState',
);
// For Form State persistence (only 1 form's values can be saved at a time)
export const formStateVar = makePersistentVar({}, 'formState');
export const switchingAccountsVar = makeVar(false);
// persistent state for modals and modal props, enables search param modal state to operate correctly
export const modalStateVar = makeVar({});
export const showExitPromptVar = makePersistentVar(false, 'showExitPrompt');
export const beforeUnloadEnabledVar = makeVar(true);
export const adminViewingClientVar = makePersistentVar(
  false,
  'adminViewingClient',
);
// global reference for the current account configuration
export const currentAccountConfigVar = makeVar({});
// dashboard portfolio date filter
export const sessionFiltersVar = makePersistentVar(null, 'sessionFilters');
